<template>
  <ApplicationFooterSection>
    <ApplicationFooterSectionButton to="/onderzoek">
      Onderzoek
    </ApplicationFooterSectionButton>
  </ApplicationFooterSection>
</template>
